export const generalFaqs = [
  {
    id: 'what-is-skore',
    question: 'What is skore.info?',
    answer:
      'skore.info helps you find completed sports games worth watching without revealing the final score or winner first.',
  },
  {
    id: 'how-filters-work',
    question: 'How does the excitement filter work?',
    answer:
      'Each sport uses a non-revealing signal. NBA, NFL, and MLB use score or run difference, while soccer and NHL use total goals.',
  },
  {
    id: 'supported-sports',
    question: 'Which sports are supported?',
    answer:
      'skore has NBA, soccer, NFL, MLB, and NHL pages. The current public feed regularly shows NBA, soccer, MLB, and NHL games. NFL availability still depends on the current data feed, so the NFL page can sometimes be empty.',
  },
];

export const sportFaqsBySport = {
  nba: [
    {
      id: 'nba-spoiler-free',
      question: 'How does the NBA page stay spoiler-free?',
      answer:
        'NBA game cards hide the final result by default so you can browse completed basketball games without seeing the winner until you choose to reveal scores.',
    },
    {
      id: 'nba-filter',
      question: 'What does the NBA excitement filter mean?',
      answer:
        'The NBA page filters games by point difference. Lower thresholds surface tighter finishes, while higher thresholds include more comfortable wins.',
    },
    {
      id: 'nba-playoffs',
      question: 'Does the NBA page include playoff games?',
      answer:
        'Coverage depends on the current feed, but completed regular-season and postseason NBA games can both appear when they are available.',
    },
  ],
  nfl: [
    {
      id: 'nfl-spoiler-free',
      question: 'How does the NFL page stay spoiler-free?',
      answer:
        'The NFL page hides scores by default so you can pick completed football games to watch without learning the result first.',
    },
    {
      id: 'nfl-filter',
      question: 'What does the NFL excitement filter mean?',
      answer:
        'NFL games are filtered by point difference. Smaller values favor one-score games and tighter finishes, while larger values broaden the list.',
    },
    {
      id: 'nfl-postseason',
      question: 'Can the NFL page show playoff games or the Super Bowl?',
      answer:
        'Yes, as long as those completed games are present in the current data feed. skore does not limit the NFL page to regular-season matchups.',
    },
  ],
  mlb: [
    {
      id: 'mlb-spoiler-free',
      question: 'How does the MLB page stay spoiler-free?',
      answer:
        'The MLB page hides the final score by default so you can choose completed baseball games without seeing the outcome in advance.',
    },
    {
      id: 'mlb-filter',
      question: 'What does the MLB excitement filter mean?',
      answer:
        'MLB games are filtered by run difference. Lower values emphasize closer baseball games, including extra-inning finishes when those are in the feed.',
    },
    {
      id: 'mlb-postseason',
      question: 'Does the MLB page include postseason games?',
      answer:
        'It can. If the current feed includes completed playoff or World Series games, they can appear on the MLB page alongside regular-season games.',
    },
  ],
  nhl: [
    {
      id: 'nhl-spoiler-free',
      question: 'How does the NHL page stay spoiler-free?',
      answer:
        'The NHL page keeps final scores hidden by default so you can browse completed hockey games without immediately seeing the result.',
    },
    {
      id: 'nhl-filter',
      question: 'What does the NHL excitement filter mean?',
      answer:
        'NHL games are filtered by total goals. Higher thresholds narrow the list to more open, higher-scoring hockey games.',
    },
    {
      id: 'nhl-playoffs',
      question: 'Can the NHL page show playoff games?',
      answer:
        'Yes. Completed playoff and regular-season NHL games can both appear when they are available in the current feed.',
    },
  ],
  soccer: [
    {
      id: 'soccer-spoiler-free',
      question: 'How does the soccer page stay spoiler-free?',
      answer:
        'The soccer page hides the final score by default so you can browse completed football matches without learning the result first.',
    },
    {
      id: 'soccer-filter',
      question: 'What does the soccer excitement filter mean?',
      answer:
        'The soccer page filters matches by total goals. A threshold of 1 removes scoreless draws, while higher thresholds focus on more open and higher-scoring matches.',
    },
    {
      id: 'soccer-competition-filter',
      question: 'Can I filter soccer by league or tournament?',
      answer:
        'Yes. When a league or tournament is present in the current soccer feed, skore can expose it as a competition filter. That includes domestic leagues, continental tournaments, and international competitions when completed games are available.',
    },
    {
      id: 'soccer-wc26',
      question: 'Will the soccer page support future international tournaments?',
      answer:
        'Yes. The soccer page already supports spoiler-free completed-match browsing and competition-based filtering. When completed tournament matches land in the feed, skore can surface them under the competition name supplied by the data source.',
    },
  ],
};
